import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

import * as styles from './Header.sty.js';
import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import type { WithChildren } from '../../core/types/with-children.js';

/**
 * @public
 * @deprecated Deprecated along with the `Page` component. Please use `PageLayout.Header` instead.
 */
export interface HeaderProps
  extends WithChildren,
    Omit<HTMLAttributes<HTMLDivElement>, keyof StylingProps>,
    StylingProps,
    DataTestId {}

/**
 * The `Header` component is used inside the `Page` component for displaying content at the very top of the page.
 * @public
 * @deprecated The `Page.Header` component is deprecated. Please use `PageLayout.Header` instead.
 */
export const Header = (props: HeaderProps) => {
  const {
    children,
    className,
    style,
    'data-testid': dataTestId,
    ...remainingProps
  }: HeaderProps = props;

  return (
    <div
      className={clsx(className, styles.header)}
      style={style}
      data-testid={dataTestId}
      {...remainingProps}
    >
      {children}
    </div>
  );
};
Header.displayName = 'Page.Header';
